import { render, staticRenderFns } from "./AddFormulaModal.vue?vue&type=template&id=2a43de77"
import script from "./AddFormulaModal.vue?vue&type=script&lang=js"
export * from "./AddFormulaModal.vue?vue&type=script&lang=js"
import style0 from "./AddFormulaModal.vue?vue&type=style&index=0&id=2a43de77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports